// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__PY7ap","checkboxCol":"Table_checkboxCol__3I3bt","emailCol":"Table_emailCol__3XoK8","actionCol":"Table_actionCol__rRU9O"};